import { Badge } from "@/components/ui/badge";
import type { StavZakazky } from "@/api/schemas";

const STAV_LABELS: Record<StavZakazky, string> = {
  ponuka: "Ponuka",
  v_priprave: "V príprave",
  vo_vyrobe: "Vo výrobe",
  dokoncena: "Dokončené",
};

/** Kedy appka stav mení sama (`services/vo_vyrobe.py` na serveri, KOLO 204). */
export const STAV_POPIS =
  "Stav sa riadi automaticky: výpočet = ponuka, zákazka AA/Z alebo výrobná " +
  "varianta = v príprave, odoslané na pílu = vo výrobe, faktúra = dokončené";

/** Farebný badge stavu zákazky podľa DESIGN_SYSTEM.md. */
export function StavBadge({ stav }: { stav: StavZakazky }): JSX.Element {
  return <Badge variant={stav}>{STAV_LABELS[stav]}</Badge>;
}

export { STAV_LABELS };
